import { createSelector } from 'reselect';

export const getMerchants = state =>
  state.merchants.directMerchants.index.directMerchants.users;

export const getCurrentPage = state =>
  state.dashboard.referrals.merchants.currentPage;

const perPage = 10;
const paginate = (list, page) =>
  list.slice((page - 1) * perPage, page * perPage);

export const getPaginatedMerchants = createSelector(
  getMerchants,
  getCurrentPage,
  paginate
);

const getMostRecent = merchants => merchants.slice(0, 5);

export const getMostRecentMerchants = createSelector(
  getMerchants,
  getMostRecent
);
